import { LoadingScreen } from "@flat-ui";
import { QueryParams } from "@router/route-params";
import { runtimeConfig } from "@src/runtime-config";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SSOLoginForm } from "@pages/sso-login/sso-login-form";

/**
 * Component that redirects the user to their custom Single Sign-On (SSO) login page.
 * If the SSO ID is not provided by the query parameter it shows a form to fill it out.
 */
export function SSOLogin(): JSX.Element {
  const [searchParams] = useSearchParams();
  const email = searchParams.get(QueryParams.email);
  const redirectUrlParam = searchParams.get(QueryParams.redirectUrl);
  const redirectUrl = redirectUrlParam || runtimeConfig.urls.sphereDashboardUrl;
  const ssoIdParam = searchParams.get(QueryParams.company);
  const [ssoId, setSSOId] = useState<string | null>(ssoIdParam);

  // Redirect to the login page for the custom SSO provider
  useEffect(() => {
    if (ssoId && ssoId.length > 0) {
      const url = new URL(
        `oauth/v1/company/${ssoId}/signin`,
        runtimeConfig.urls.apiBaseUrl
      );
      url.searchParams.set(QueryParams.redirectUrl, redirectUrl);

      if (email) {
        url.searchParams.set(QueryParams.email, email);
      }

      window.location.href = url.href;
    }
  }, [ssoId, email, redirectUrl]);

  return (
    <>
      {!ssoId && <SSOLoginForm setSSOId={setSSOId} />}
      {ssoId && <LoadingScreen />}
    </>
  );
}
